class FsParallaxImage extends HTMLElement {
  constructor () {
    super()

    const parallaxSetting = this.getAttribute('data-parallax')

    if (parallaxSetting === 'none') {
      return
    }

    const mm = gsap.matchMedia()

    const elImage = this.querySelector('img')

    mm.add('(prefers-reduced-motion: no-preference)', () => {
      gsap.registerPlugin(ScrollTrigger)

      this.tl = gsap.timeline({
        scrollTrigger: {
          trigger: this,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true,
        },
      })
        .to(elImage, {
          yPercent: () => 20,
          ease: 'none',
        })
    })
  }
}

if (!customElements.get('fs-parallax-image')) {
  customElements.define('fs-parallax-image', FsParallaxImage)
}
